import React from 'react'
import AppCombobox from '../AppCombobox'

export default function FacultyVenueSection({
  // Faculty
  showFaculty = true,
  faculty = '',
  onFacultyChange,
  facultyOptions = [],

  // Extra Lecture checkbox
  showExtraLecture = false,
  extraLecture = false,
  onExtraLectureChange,

  // Classroom / Location
  showClassroom = true,
  classroom = '',
  onClassroomChange,
  classroomOptions = [],
  classroomLabel = 'Location / Classroom',
  classroomPlaceholder = 'Select Classroom / Hall...',

  // URLs
  showLiveUrl = false,
  liveUrl = '',
  onLiveUrlChange,

  showVideoUrl = false,
  videoUrl = '',
  onVideoUrlChange,
}) {
  return (
    <section className="rounded-3xl border border-outline-variant/30 bg-surface-container-lowest shadow-xs">
      {/* ── Header ── */}
      <div className="border-b border-outline-variant/20 bg-surface-container-low/60 px-6 py-4 rounded-t-3xl flex items-center gap-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-indigo-500/10 text-indigo-600">
          <span className="material-symbols-outlined text-lg">co_present</span>
        </div>
        <div>
          <h2 className="font-display text-base font-bold text-on-surface">
            Faculty, Venue &amp; Delivery
          </h2>
          <p className="text-xs text-on-surface-variant">
            Assign visiting or permanent faculty, specify physical hall or lab, and provide stream links.
          </p>
        </div>
      </div>

      {/* ── Fields ── */}
      <div className="p-6 md:p-8 flex flex-col gap-5 text-xs">
        
        {/* Faculty */}
        {showFaculty && (
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-12 sm:col-span-3 text-xs font-black uppercase tracking-wider text-on-surface-variant">
              Faculty<span className="text-error font-bold"> *</span>
            </span>
            <div className={`col-span-12 ${showExtraLecture ? 'sm:col-span-6' : 'sm:col-span-9'}`}>
              <AppCombobox
                options={facultyOptions}
                value={faculty}
                onChange={onFacultyChange}
                placeholder="Select Faculty..."
                triggerClassName="h-10 w-full bg-surface-container-low text-xs font-bold text-on-surface"
              />
            </div>
            {showExtraLecture && (
              <div className="col-span-12 sm:col-span-3">
                <label className="inline-flex items-center gap-2 rounded-xl bg-surface-container-low px-3.5 py-2 border border-outline-variant/20 cursor-pointer select-none text-[11px] font-bold text-on-surface transition hover:bg-surface-container-high whitespace-nowrap">
                  <input
                    type="checkbox"
                    checked={extraLecture}
                    onChange={(e) => onExtraLectureChange?.(e.target.checked)}
                    className="h-4 w-4 rounded border-outline-variant text-primary focus:ring-primary/20 accent-primary"
                  />
                  <span>Extra Lecture</span>
                </label>
              </div>
            )}
          </div>
        )}

        {/* Location / Classroom */}
        {showClassroom && (
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-12 sm:col-span-3 text-xs font-black uppercase tracking-wider text-on-surface-variant">
              {classroomLabel}
            </span>
            <div className="col-span-12 sm:col-span-9">
              <AppCombobox
                options={classroomOptions}
                value={classroom}
                onChange={onClassroomChange}
                placeholder={classroomPlaceholder}
                triggerClassName="h-10 w-full bg-surface-container-low text-xs font-semibold"
              />
            </div>
          </div>
        )}

        {/* Live URL */}
        {showLiveUrl && (
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-12 sm:col-span-3 text-xs font-black uppercase tracking-wider text-on-surface-variant">
              Live Stream URL
            </span>
            <div className="col-span-12 sm:col-span-9">
              <input
                type="url"
                value={liveUrl}
                onChange={(e) => onLiveUrlChange?.(e.target.value)}
                placeholder="https://meet.google.com/..."
                className="h-10 w-full rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-xs font-medium text-on-surface outline-none focus:ring-2 focus:ring-primary/20 focus:bg-surface-container-lowest transition"
              />
            </div>
          </div>
        )}

        {/* Video URL */}
        {showVideoUrl && (
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-12 sm:col-span-3 text-xs font-black uppercase tracking-wider text-on-surface-variant">
              Recorded Video URL
            </span>
            <div className="col-span-12 sm:col-span-9">
              <input
                type="url"
                value={videoUrl}
                onChange={(e) => onVideoUrlChange?.(e.target.value)}
                placeholder="https://youtube.com/..."
                className="h-10 w-full rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-xs font-medium text-on-surface outline-none focus:ring-2 focus:ring-primary/20 focus:bg-surface-container-lowest transition"
              />
            </div>
          </div>
        )}

      </div>
    </section>
  )
}
